module.exports = __webpack_public_path__ + "img/春节大促_13.0b6cbde1.png";